import WebConstant from "../../webConstants";
import { mainWrapper } from "../../main";

function adminListing(params) {
    return mainWrapper.get(WebConstant.host + `/admin`, params);
};

function adminCreate(params) {
    return mainWrapper.post(WebConstant.host + `/admin`, params);
};

function adminDetail(id) {
    return mainWrapper.get(WebConstant.host + `/admin/${id}`);
};

function adminUpdate(params, id) {
    return mainWrapper.put(WebConstant.host + `/admin/${id}`, params);
};

function adminDelete(id) {
    return mainWrapper._delete(WebConstant.host + `/admin/${id}`);
};


function updateAdminStatus(id, params) {
    return mainWrapper.put(WebConstant.host + `/update_admin_status/${id}`, params);
};


export const adminServices = {
    adminListing,
    adminCreate,
    adminDetail,
    adminUpdate,
    adminDelete,
    updateAdminStatus,
};
